import React, { Component, Fragment } from "react";
import "../../styles/Popup.module.css";
import { Form, Input } from "antd";
import { connect } from "react-redux";
import { requestServerPost, selectPage } from "../../actions";
import PopupManager from "../../managers/PopupManager";
import Colors from "../../config/Colors";
import { Copy } from "lucide-react";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";

const formItemLayout = {
  labelCol: { span: 0 },
  wrapperCol: { span: 24 },
};

const dummyRequest = ({ file, onSuccess }) => {
  setTimeout(() => {
    onSuccess("ok");
  }, 0);
};

class DuplicateCampaignPage extends Component {
  constructor(props) {
    super(props);
    const { data = null } = props;

    const campaignName = data ? data.CampaignName : "";

    if (!data || !data.BrandLogo || data.BrandLogo === "") {
      this.state = {
        campaignname: campaignName,
        fileList: [],
        files: [],
        data: data,
      };

      return;
    }

    this.state = {
      campaignname: campaignName,
      data: data,
      color: data.CampaignColor ? data.CampaignColor : Colors.lightblue,
    };
  }

  onFinish = (values) => {
    const {
      requestServerPost,
      usertoken,
      data = null,
      selectedBrandData,
    } = this.props;
    var params = new FormData();

    if (!data) {
      params.append("brandid", selectedBrandData.BrandID);
      params.append("campaignname", values.campaignname);
      params.append("campaigncolor", this.state.color);

      console.log("crerate_campaign " + JSON.stringify(params));
      requestServerPost(
        "create_campaign",
        params,
        {},
        (response) => {
          PopupManager.closePopup();
        },
        usertoken,
      );
    } else {
      params.append("campaignid", data.CampaignID);
      params.append("campaignname", values.campaignname);
      params.append("campaigncolor", this.state.color);

      console.log("duplicate_campaign " + JSON.stringify(params));
      requestServerPost(
        "duplicate_campaign",
        params,
        {},
        (response) => {
          PopupManager.closePopup();
        },
        usertoken,
      );
    }
  };

  onBackgroundColorChanged = (newcolor) => {
    // const newLayout = { ...currentLayout };
    // newLayout.background_color = color;
    // setCurrentLayout(newLayout);

    this.setState({ color: newcolor });
  };

  render() {
    const { data = null } = this.props;
    const t = this.props.langT || PRO_TRANSLATIONS.en.createCampaignPopup;
    const color = data
      ? data.CampaignColor
        ? data.CampaignColor
        : Colors.defaultcampaign
      : Colors.defaultcampaign;
    const previewStyle = {
      display: "inline",
      width: 100,
      height: 100,
    };

    const bleed = { margin: -24, overflow: "hidden" };
    const body = { maxWidth: 440, margin: "0 auto", padding: "32px 40px" };

    return (
      <div style={{ ...bleed }}>
        <div
          style={{
            background: "linear-gradient(135deg,#6366f1 0%,#4f46e5 100%)",
            padding: "36px 40px",
            textAlign: "center",
            color: "#fff",
          }}
        >
          <div
            style={{
              width: 56,
              height: 56,
              borderRadius: 16,
              background: "rgba(255,255,255,0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 14px",
            }}
          >
            <Copy size={28} color="#fff" />
          </div>
          <div style={{ fontSize: 22, fontWeight: 700, marginBottom: 6 }}>
            {t.duplicateTitle}
          </div>
          <div style={{ fontSize: 14, color: "rgba(255,255,255,0.75)" }}>
            {t.duplicateSubtitle}
          </div>
        </div>
        <div style={{ ...body }}>
          <Form
            name="duplicate_campaign_form"
            {...formItemLayout}
            key={`${data ? data.CampaignID + "_dup_campaign" : "dup_campaign"}`}
            onFinish={this.onFinish}
            initialValues={{ campaignname: this.state.campaignname }}
            onValuesChange={(_, all) =>
              this.setState({ campaignname: all.campaignname || "" })
            }
          >
            <div style={{ marginBottom: 28 }}>
              <label
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#64748b",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                  display: "block",
                  marginBottom: 6,
                }}
              >
                {t.newNameLabel}
              </label>
              <Form.Item
                name="campaignname"
                style={{ marginBottom: 0 }}
                rules={[{ required: true, message: t.nameRequired }]}
              >
                <Input
                  size="large"
                  placeholder={t.newNamePlaceholder}
                  style={{ borderRadius: 10 }}
                  autoFocus
                />
              </Form.Item>
            </div>
            <Form.Item style={{ marginBottom: 0 }}>
              <button
                type="submit"
                style={{
                  width: "100%",
                  height: 48,
                  borderRadius: 10,
                  border: "none",
                  background: "linear-gradient(135deg,#6366f1,#4f46e5)",
                  color: "#fff",
                  fontSize: 15,
                  fontWeight: 600,
                  cursor: "pointer",
                  boxShadow: "0 2px 10px rgba(99,102,241,0.3)",
                }}
              >
                {t.duplicateButton}
              </button>
            </Form.Item>
          </Form>
        </div>
      </div>
    );
  }
}

const Styles = {};

const mapStateToProps = (state) => {
  return {
    userdata: state.userdata,
    usertoken: state.usertoken,
    selectedBrandData: state.selectedBrandData,
  };
};

const ConnectedDuplicateCampaignPage = connect(mapStateToProps, {
  requestServerPost,
  selectPage,
})(DuplicateCampaignPage);

const DuplicateCampaignPageWithLang = (props) => {
  const { lang } = useProLanguage();
  const t =
    PRO_TRANSLATIONS[lang]?.createCampaignPopup ||
    PRO_TRANSLATIONS.en.createCampaignPopup;
  return <ConnectedDuplicateCampaignPage langT={t} {...props} />;
};

export default DuplicateCampaignPageWithLang;
